import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class QuickAccessService {
    private quickAccessListSubject = new BehaviorSubject<QuickAccessItem[]>([]);

    public quickAccessList$: Observable<QuickAccessItem[]> = this.quickAccessListSubject.asObservable();

    constructor(private datatask: DataTaskService) {}

    public async loadQuickAccessListObservable() {
        this.quickAccessListSubject.next(await this.getQuickAccessList());
    }

    /**
     * Retrieves list of quick access points.
     *
     * @datatask 3942
     * @datataskName tt_get_usergroup_favorites_list
     * @returns promise containing list of quick access points.
     */
    public async getQuickAccessList(): Promise<QuickAccessItem[]> {
        return this.datatask.Post(3942);
    }

    /**
     * Retrieves state and params for dynamic goto item.
     *
     * @datatask 3926
     * @datataskName tt_dynamic_datatask_goto
     * @returns promise item and state to go to.
     */
    public async getDynamicDatataskGoto(params: GetDynamicDatataskParams): Promise<DynamicDatataskGotoGet> {
        return (await this.datatask.Post(3926, params))[0];
    }
}

export interface QuickAccessItem {
    item_name: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
}

export interface GetDynamicDatataskParams {
    p2_datatask_keyno: string | number;
}

export interface DynamicDatataskGotoGet {
    item_state: string;
    item_parms: string;
}
